export default __webpack_public_path__ + "053712a65603452835f21b155c19d693.svg";